import { Component, OnInit, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SetUserLocale } from 'src/app/auth/state/auth/auth.actions';
import { LocaleModel } from 'src/app/shared/models/locale.model';
import { locales } from 'src/app/locale-config.module';
import { DialogService } from 'src/app/dialogs/dialog.service';

@Component({
  selector: 'app-locale-menu',
  templateUrl: './locale-menu.component.html',
  styleUrls: ['./locale-menu.component.scss']
})
export class LocaleMenuComponent implements OnInit, OnDestroy {

  private ngUnsubscribe = new Subject();
  
  locales: LocaleModel[] = locales;

  @Select(AuthState.getUserLocale)
  userLocale$: Observable<LocaleModel>;

  constructor(
    private store: Store,
    private dialogService: DialogService
    ) { }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleLocaleSelected(locale: LocaleModel) {
    const dialogRef = this.dialogService.openConfirmDialog({
      data: {
        titleText: 'Confirm Language Selection',
        bodyText: `Your language will be changed to "${locale.title}"?`,
        confirmText: 'Set Language',
        confirmColor: 'warn'
      }
    });

    dialogRef.afterClosed()
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(confirmed => {
        if (confirmed) {
          this.store.dispatch(new SetUserLocale(locale));
          window.location.reload();
        }
      });
  }

}
